<template>
  <div class="forget-page c-layout">
    <div class="breadcrumbs c-layout hide-on-pad">
      <span>{{ $t('breadcrumbs.home') }}</span>
      <span class="p-16">/</span>
      <span>{{ $t('breadcrumbs.user_center') }}</span>
      <span class="p-16">/</span>
      <span class="o-color">{{ $t('breadcrumbs.forget') }}</span>
    </div>
    <div class="page-title">{{ $t('breadcrumbs.forget') }}</div>
    <div class="page-container">
      <div class="page-left hide-on-pad">
        <!-- <user-side-menu page="forget"/> -->
      </div>
      <div class="page-right ">
        
        <div class="form-desc">{{ $t('forget.desc') }}</div>
        <div class="form">
          <div class="form-item">
            <div class="form-title required">{{ $t('forget.account') }}<div class="required">{{ $t('form.required') }}</div></div>
            <div class="form-content">
              <div class="col-2 mb-0">
                <input type="text" :placeholder="$t('forget.account_placeholder')" v-model="account">
              </div>
            </div>
          </div>
          <div class="form-item">
            <div class="form-title">{{ $t('forget.email') }}<div class="required">{{ $t('form.required') }}</div></div>
            <div class="form-content">
              <div class="col-2 mb-0">
                <input type="text" :placeholder="$t('forget.email_placeholder')" v-model="email">
              </div>
            </div>
          </div>
        </div>

        <div class="page-btn-block">
          <div class="btn btn-orange btn-back" @click="handleGetPassword">{{ $t('btns.confirm') }}</div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { sendForget } from '@/api';
import { cloudLoading,cloudConfirm } from '../../utils/tools.js'
import userSideMenu from '../../components/UserSideMenu'

  export default {
    name: 'forget',
    data() {
      return {
        email: '',
        account: '' // luhoe@yahoo.com.tw
      }
    },
    components: {
      userSideMenu
    },
    methods: {
      async handleGetPassword() {
        if(this.email=='' || this.account==''){
          this.$message({
            message: this.$t('alert_message.insert_account_email'),
            type: 'warning'
          })  
          return;
        }
        const loadingInstance = cloudLoading();
        try {
          const res = await sendForget({ username:this.account, email:this.email });
          this.$message({
            message: this.$t('alert_message.send_success'),
            type: 'success'
          });
          loadingInstance.close();
        } catch (error) {
          loadingInstance.close();
          // luhoe@yahoo.com.tw
        }
        
      }
    }
  }
</script>

<style lang="less" scoped>
.forget-page {
  .page-container {
    @media (max-width: 992px) {
      padding-top: 0;
    }
    .page-right  {
      width: 100%;
      margin-bottom: 30px;
    }
  }
  .form-desc {
    margin: 30px 0 20px 0;
    @media (max-width: 992px) {
      margin: 10px 0 10px 0;
      padding-bottom: 10px;
      font-size: 13px;
      border-bottom: 1px solid #E6E6E6;
      text-align: center;
    }
  }
  .form {
    margin-bottom: 40px;
    .btn {
      margin-bottom: 20px;
      width: 100%;
      margin-left: 20px;
    }
    .form-item {
      display: flex;
      border-bottom: 1px solid #E6E6E6;
      &:nth-child(1) {
        border-top: 1px solid #E6E6E6;
      }
      .form-title {
        background: #F3F3F3;
        width: 220px;
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        .required {
          position: absolute;
          color: #FF5214;
          border: 1px solid #FF5214;
          padding: 3px;
          border-radius: 5px;
          right: 20px;
          font-size: 14px;
        }
        .label-group {
          margin-top: 10px;
          input[type="checkbox"] {
            flex: 0 0 16px;
          }
          // label {
          //   &::before {
          //     border-radius: 0;
          //   }
          //   &::after {
          //     border-radius: 0;
          //   }
          // }
        }
      }
      .form-content {
        flex: 1;
        padding: 20px;
        display: flex;
        flex-wrap: wrap;
        position: relative;
        .col-1,.col-2,.col-3 {
          margin-bottom: 20px;
          &:nth-last-child(1) {
            margin-bottom: 0;
          }
        }
        .col-1 {
          flex: 0 0 33.333%;
          display: flex;
        }
        .col-2 {
          flex: 0 0 66.666%;
          display: flex;
        }
        .col-3 {
          flex: 0 0 100%;
          display: flex;
        }
        input[type="text"] {
          margin-right: 20px;
          padding: 10px;
          // 下面这两行 为了修正inpu在flex里面会有溢出的问题，随便给个比预期小的就好
          min-width: 16px;
          width: 16px;
          &:nth-last-child(1) {
            margin-right: 0;
          }
        }
        select {
          flex: 1;
          margin-right: 20px;
          font-size: 13px;
          &:nth-last-child(1) {
            margin-right: 0;
          }
        }
        .show-value {
          width: 100%;
          span {
            position: absolute;
            top: 14px;
            right: 10px;
            border: 1px solid #fff;
          }
          span.red {
            color: #07BB6B;
            border-color: #07BB6B;
            padding: 5px;
            width: 100px;
            text-align: center;
          }
          span.green {
            color: #A72121;
            border-color: #A72121;
            padding: 5px;
            width: 100px;
            text-align: center;
          }
        }
      }
    }
    @media (max-width: 992px) {
      background: #F7F8FA;
      border-radius: 5px;
      box-shadow: 0px 4px 8px 4px rgba(0,0,0,.15);
      margin-bottom: 30px;
      .btn {
        font-size: 13px;
      }
      .form-item {
        flex-direction: column;
        padding: 10px 5px;
        border-top: unset !important;
        border-bottom: unset;
        .form-title {
          width: 100%;
          padding: 10px 0;
          background: unset;
          font-size: 14px;
          padding-left: 10px;
          &.required {
            position: relative;
            &::before {
              content: '*';
              position: absolute;
              top: 9px;
              left: 1px;
            }

          }
          .required {
            display: none;
          }
          .label-group {
            display: none;
          }
        }
        .form-content {
          width: 100%;
          padding: 0;
          .col-1,.col-2,.col-3 {
            flex: 0 0 100%;
            &.input-mix-btn {
              position: relative;
              .btn {
                position: absolute;
                right: 0;
                top: 0;
                width: 100px;
                height: 100%;
                border-top-right-radius: 6px;
                border-bottom-right-radius: 6px;
              }
              input {
                padding-right: 100px;
              }
            }
          }
          input,select {
            border: 1px solid #E6E6E6;
            border-radius: 6px;
          }
          .label-group {
            input[type="checkbox"],input[type="radio"] {
              flex: 0 0 16px;
            }
            label {
              &::before {
                background: white;
                border-color: #E6E6E6;
              }
              &::after {
                // border-radius: 10px;
              }
            }
          }
          .show-value {
            border: 1px solid #E6E6E6;
            text-align: center;
            width: 100%;
            padding: 10px;
            border-radius: 6px;
            position: relative;
            span {
              position: absolute;
              top: 5px;
              right: 10px;
            }
            span.red {
              color: #07BB6B;
              border: unset;
            }
            span.green {
              color: #A72121;
              border: unset;
            }
          }
        }
      }
    }
  }
  .page-btn-block {
    display: flex;
    justify-content: center;
    .btn {
      margin: unset;
      margin-right: 20px;
      width: 125px;
      &:nth-last-child(1) {
        margin-right: 0;
      }
    }
    @media (max-width: 992px) {
      position: fixed;
      width: 100%;
      left: 0;
      bottom: 0;
      z-index: 1;
      .btn {
        width: unset;
        flex: 1;
        margin-right: 0;
      }
    }
  }
}
</style>